import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Table, Row, Col, Card, CardBody, Container } from 'reactstrap';
import { TablePagination } from '../../Components/Pagination'
import { getCategoryData } from '../../API/Backend';
import { showToast } from '../../Components/Toast';
import Skeleton from "react-loading-skeleton";
import Image from '../../Components/Image'


const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [keyword, setKeyword] = useState("");
  const keywordRef = useRef("");

  useEffect(() => {
    fetchCategories();
  }, [])

  const fetchCategories = (limit = 10, offset = 0, keyword = "") => {
    setLoading(true)
    setCategories([])
    getCategoryData({ limit: limit, offset: offset, ...(keyword && keyword.length && { search: keyword }) }).then(({ data }) => {
      if (data.data) {
        // console.log('categories', data)
        setCategories(data.data ? data.data.categories : [])
        setCount(data.data ? data.data.count : 0)
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setLoading(false)
    })
  }

  const onPaginationChange = (currentPage) => {
    if (page !== currentPage) {
      setPage(currentPage);
      fetchCategories(limit, limit * (currentPage - 1), keyword)
    }
  }

  const searchByKeyword = (e) => {
    e.preventDefault();
    setKeyword(keywordRef.current.value);
    fetchCategories(limit, 0, keywordRef.current.value)
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <h5 className="page-title">Banners</h5>
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md="12">
                  <div className='d-flex align-items-center gap-5'>
                    <div className='table-size-container'>
                      <span>Showing</span>
                      <select className='table-size-control' value={limit} onChange={(e) => { setLimit(Number(e.target.value)); fetchCategories(Number(e.target.value), 0, "") }}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                      <span>entries</span>
                    </div>
                    <div className="table-search-box">
                      <input type="search" id="customSearch" placeholder="Search Here..." ref={keywordRef} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); searchByKeyword(e); } }} />
                      <button disabled={loading} onClick={(e) => { searchByKeyword(e) }}><i className="ri-search-line"></i></button>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table>
                    <thead>
                      <tr>
                        <th>Category Name</th>
                        <th>Category Image</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ?
                          [...Array(15)].map((a, i) => {
                            return <tr key={i}>
                              <td><div><Skeleton height={40} width={80} className='me-2' /></div></td>
                              <td><Skeleton height={12} width={80} /></td>
                              <td><Skeleton height={20} width={60} /></td>
                              <td><Skeleton height={30} width={60} /></td>
                            </tr>
                          }) :
                          !categories.length ?
                            <tr><td colSpan="4" className="text-center fs-12 fw-600"><span className="d-flex align-items-center justify-content-center"><i className="ri-error-warning-line text-danger fs-22 fw-300 me-2"></i> No categories found</span></td></tr> :
                            categories.map((category, i) => (
                              <tr key={category._id}>
                                <td>{category.title}</td>
                                <td>
                                  <Image src={`${process.env.REACT_APP_IMAGE_DIRECTORY}/category/${category?.image}`} alt={category?.image} className='me-2' height='40px' width='70px' objectFit='cover' />
                                </td>
                                <td>
                                  <Link to={'/category/edit/' + category._id} className='btn btn-rounded btn-outline-secondary btn-small'><i className="ri-edit-line"></i> Edit</Link>
                                </td>
                              </tr>
                            ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <TablePagination limit={limit} page={page} currentRecords={categories.length} total={count} loading={false} onPaginationChange={(p) => onPaginationChange(p)} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
export default Categories